import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm, getFormValues, change } from "redux-form";

import { Button, CustomDropdownByValue, CheckButton } from "components";
import { AmexVmcdSection } from "components/formSections";
import { FundingTypes } from "types";
import { required } from "validators/validation";

import styles from "./../underwritingFormSections.module.scss";

const FORM_NAME = "underwritingCardInfo";

let CardInfoSectionForm = ({
	handleSubmit,
	isFormDisabled,
	initialValues,
	dispatch,
	loading,
	handleIsDailyDiscountChange,
}) => {
	useEffect(() => {
		if (initialValues?.fundingType !== undefined) {
			const selectedFundingType = FundingTypes.getByValue(
				initialValues?.fundingType,
			);
			dispatch(
				change(FORM_NAME, "fundingType", selectedFundingType?.value),
			);
		}
	}, [initialValues, dispatch]);

	const fundingTypes = FundingTypes.getOptions();

	const onIsDailyDiscountChange = (e, value) => {
		handleIsDailyDiscountChange(value);
	};

	return (
		<Form onSubmit={handleSubmit}>
			<div className={styles.cardInfoSection}>
				<AmexVmcdSection
					allDisabled={isFormDisabled}
					initialTabIndex={1}
					loading={loading}
				/>

				<div className={styles.funding}>
					<Field
						component={CustomDropdownByValue}
						smSelect={12}
						validate={[required]}
						name="fundingType"
						disabled={isFormDisabled}
						items={fundingTypes}
						labelName="displayName"
						label="Funding Types"
						wrapperClassName={styles.dropdown}
					/>

					<Field
						component={CheckButton}
						label="Daily Discount"
						id="customCheckList"
						disabled={isFormDisabled}
						name="isDailyDiscount"
						onChange={onIsDailyDiscountChange}
					/>
					<Button
						type="submit"
						disabled={isFormDisabled}
						value="Save"
						variant="secondary"
						minWidth="auto"
						className="ml-4"
					/>
				</div>
			</div>
		</Form>
	);
};

CardInfoSectionForm = reduxForm({
	form: FORM_NAME,
	destroyOnUnmount: false,
	enableReinitialize: true,
})(CardInfoSectionForm);

CardInfoSectionForm = connect(
	(state, ownProps) => ({
		loading: ownProps.loadingUpdateCardInfo || state.merchantInfo.loading,
		initialValues: ownProps.initialValues,
		formValues: getFormValues(FORM_NAME)(state),
	}),
	null,
)(CardInfoSectionForm);

export default CardInfoSectionForm;
